/* eslint-disable */
import SearchController from '../common/SearchController';
import { initCountrySeoTracking } from '@/js/common/Domain/Service/tracking/countrySeoTracking';
import './css/country-ai-blocks.scss';

$(() => {
	const searchController = new SearchController({
		el: 'body'
	});

	searchController.initSearchOnScroll();
	initCountrySeoTracking();
});
